const headers = [
  { text: 'Câu lạc bộ', value: 'name' },
  { text: 'Số lượng học sinh tham gia', value: 'joinNumberCompare' },
  { text: 'T.Thái hiển thị', value: 'published', align: 'center' },
  { text: 'T.Thái đăng ký', value: 'isOpenRegister', align: 'center' },
  { text: 'Thao tác', value: 'actions', width: '80px' }
]

export { headers }
